import { AnyObject } from "@/interfaces/Fetch";
import { DateTime } from "luxon";

/**
 * This function allow us to have only that what we need to update an entity
 *
 * @example
 * Before :
 * ObjectA = {"firstname": "Ilan", "lastname": "JOURNO"}
 * After :
 * ObjectB = {"firstname": "Ilan", "lastname": "Nolina"}
 * Result :
 * @returns
 * Output = {"lastname": "Nolina"}
 */
const getDifferenceBetweenTwoObjects = <T>(
  objectA: AnyObject | undefined | null,
  objectB: AnyObject
) => {
  if (objectA) {
    const result: AnyObject = {};
    Object.entries(objectB).forEach(([key, element]) => {
      if (key !== "id" && objectA[key] === element) return;
      else if (element instanceof FileList) {
        if (element.length > 0) result[key] = element;
        return;
      } else if (element instanceof File) {
        result[key] = element;
        return;
      } else if (
        typeof objectA[key] === "object" &&
        element !== null &&
        typeof element === "object"
      ) {
        const elements = getDifferenceBetweenTwoObjects<AnyObject>(
          objectA[key],
          element
        );
        if (Object.keys(elements).length !== 0) {
          result[key] = elements;
        }
        return;
      }
      result[key] = element === "" ? null : element;
    });
    return result as T;
  }

  return objectB as T;
};

export const matchPassword = (value: string = "", matchValue: string = "") => {
  return value === matchValue || "Les mots de passe ne correspondent pas";
};

export const isIterableArray = (array?: any[]) =>
  Array.isArray(array) && !!array.length;

export const createFormDataRequest = (body: { [key: string]: any }) => {
  const formData = new FormData();
  for (const key of Object.keys(body)) {
    const element = body[key];
    if (element instanceof FileList) {
      if (element.length > 0) formData.append(key, element[0]);
    } else if (
      typeof element === "string" ||
      typeof element === "number" ||
      typeof element === "boolean"
    ) {
      formData.append(key, element.toString());
    } else if (element instanceof Array && element.length > 0) {
      element.forEach((value, index) => {
        if (typeof value === "object" && !("stream" in value)) {
          appendObjectToFormData(formData, `${key}[${index}]`, value);
        } else {
          formData.append(`${key}[${index}]`, value);
        }
      });
    } else if (typeof element === "object") {
      appendObjectToFormData(formData, key, element);
    }
  }

  return formData;
};

function appendObjectToFormData(
  formData: FormData,
  rootKey: string,
  object: any
) {
  for (const key in object) {
    if (object[key] !== null) {
      if (object[key] instanceof File || object[key] instanceof DateTime) {
        formData.append(`${rootKey}['${key}']`, object[key]);
      } else if (typeof object[key] === "object") {
        appendObjectToFormData(formData, `${rootKey}['${key}']`, object[key]);
      } else if (object[key] !== undefined) {
        formData.append(`${rootKey}['${key}']`, object[key]);
      }
    }
  }
}

export default getDifferenceBetweenTwoObjects;
